import { Component, Story } from './DocTypes';

const RequiredStory: Story = {
  title: 'Required rule',
  description: 'Required rule',
  coreComponent: {
    html: `<tag-form submit-button-text='Submit' submit-button-accent='viridiangreen'>
  <tag-form-group>
    <tag-edit-field  name='Required field' label='Required field'>
        <tag-validation rule='required'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
</tag-form>`,
  },
  reactWrapper: {
    jsx: `<TagForm submitButtonText='Submit' submitButtonAccent='viridiangreen'>
  <TagFormGroup>
    <TagEditField
    name='Required field'
    label='Required field'
    validation={[{ rule: 'required'}]}/>
  </TagFormGroup>
</TagForm>`,
  },
};

const EmailStory: Story = {
  title: 'Email rule',
  description: 'Email rule',
  coreComponent: {
    html: `<tag-form submit-button-text='Submit' submit-button-accent='viridiangreen'>
  <tag-form-group>
    <tag-edit-field name='Email field' label='Email field' value='Joe.Bloggs'>
        <tag-validation rule='email' ></tag-validation>
    </tag-edit-field>
  </tag-form-group>
</tag-form>`,
  },
  reactWrapper: {
    jsx: `<TagForm submitButtonText='Submit' submitButtonAccent='viridiangreen'>
  <TagFormGroup>
    <TagEditField
    name='Email field'
    label='Email field'
    value='Joe.Bloggs'
    validation={[{ rule: 'email'}]}/>
  </TagFormGroup>
</TagForm>`,
  },
};

const LengthStory: Story = {
  title: 'Length rule',
  description: 'Length rule',
  coreComponent: {
    html: `<tag-form submit-button-text='Submit' submit-button-accent='viridiangreen'>
  <tag-form-group>
    <tag-edit-field name='Max length' label='Max length' value='123456'>
        <tag-validation rule='maxlength' args='5'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
  <tag-form-group>
    <tag-edit-field name='Min length' label='Max length' value='1'>
        <tag-validation rule='minlength' args='5'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
</tag-form>`,
  },
  reactWrapper: {
    jsx: `<TagForm submitButtonText='Submit' submitButtonAccent='viridiangreen'>
  <TagFormGroup>
    <TagEditField
    name='Max length'
    label='Max length'
    value='123456'
    validation={[{ rule: 'maxlength', args:'5'}]}/>
  </TagFormGroup>
  <TagFormGroup>
    <TagEditField
    name='Min length'
    label='Min length'
    value='1'
    validation={[{ rule: 'minlength', args: '5'}]}/>
  </TagFormGroup>
</TagForm>`,
  },
};

const UrlStory: Story = {
  title: 'Url rule',
  description: 'Url rule',
  coreComponent: {
    html: `<tag-form submit-button-text='Submit' submit-button-accent='viridiangreen'>
  <tag-form-group>
    <tag-edit-field name='Url field' label='Url field' value='google.com'>
        <tag-validation rule='url' ></tag-validation>
    </tag-edit-field>
  </tag-form-group>
</tag-form>`,
  },
  reactWrapper: {
    jsx: `<TagForm submitButtonText='Submit' submitButtonAccent='viridiangreen'>
  <TagFormGroup>
    <TagEditField
    name='Url field'
    label='Url field'
    value='google.com'
    validation={[{ rule: 'url'}]}/>
  </TagFormGroup>
</TagForm>`,
  },
};

const ArrayStory: Story = {
  title: 'Array rule',
  description: 'Array rule',
  coreComponent: {
    html: `<tag-form submit-button-text='Submit' submit-button-accent='viridiangreen'>
  <tag-form-group>
    <tag-edit-field name='In array' label='In array' value='4'>
        <tag-validation rule='inarray' args='["1","2","3"]'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
  <tag-form-group>
    <tag-edit-field name='Not in array' label='Not in array' value='3'>
        <tag-validation rule='notinarray' args='["1","2","3"]'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
</tag-form>`,
  },
  reactWrapper: {
    jsx: `<TagForm submitButtonText='Submit' submitButtonAccent='viridiangreen'>
  <TagFormGroup>
    <TagEditField
    name='In array'
    label='In array'
    value='4'
    validation={[{ rule: 'inarray', args:'["1","2","3"]'}]}/>
  </TagFormGroup>
  <TagFormGroup>
    <TagEditField
    name='Not in array'
    label='Not in array'
    value='3'
    validation={[{ rule: 'notinarray', args:'["1","2","3"]'}]}/>
  </TagFormGroup>
</TagForm>`,
  },
};

const MatchStory: Story = {
  title: 'Matches rule',
  description: 'Matches rule',
  coreComponent: {
    html: `<tag-form submit-button-text='Submit' submit-button-accent='viridiangreen'>
  <tag-form-group>
    <tag-edit-field name='Detect spain label' label='Detect spain label' value='This is france'>
        <tag-validation rule='matches' args='spain' ></tag-validation>
    </tag-edit-field>
  </tag-form-group>
</tag-form>`,
  },
  reactWrapper: {
    jsx: `<TagForm submitButtonText='Submit' submitButtonAccent='viridiangreen'>
  <TagFormGroup>
    <TagEditField
    name='Detect spain label'
    label='Detect spain label'
    value='This is france'
    validation={[{ rule: 'matches', args: 'spain'}]}/>
  </TagFormGroup>
</TagForm>`,
  },
};

const RegexStory: Story = {
  title: 'Regex rule',
  description: 'Regex rule',
  coreComponent: {
    html: `<tag-form submit-button-text='Submit' submit-button-accent='viridiangreen'>
  <tag-form-group>
    <tag-edit-field name='regexTest' label='Check against regex rule (6 digits by default)' value='123456'>
        <tag-validation rule='matches' args='^[0-9]{6}$'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
</tag-form>`,
  },
  reactWrapper: {
    jsx: `<TagForm submitButtonText='Submit' submitButtonAccent='viridiangreen'>
  <TagFormGroup>
    <TagEditField
    name='regexTest'
    label='Check against regex rule (6 digits by default)'
    value='123456'
    validation={[{ rule: 'matches', args:'^[0-9]{6}$'}]}/>
  </TagFormGroup>
</TagForm>`,
  },
};

const RegexStoryPostcode: Story = {
  title: 'Complex Regex rule',
  description: 'Complex Regex rule - postcode regex',
  coreComponent: {
    html: `<tag-form submit-button-text='Submit' submit-button-accent='viridiangreen'>
  <tag-form-group>
    <tag-edit-field name='regexTest' label='Check against regex rule (postcode format)' value='LE6 0ZA'>
        <tag-validation
          rule='matches'
          args='^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$'>
        </tag-validation>
    </tag-edit-field>
  </tag-form-group>
</tag-form>`,
  },
  reactWrapper: {
    jsx: `<TagForm submitButtonText='Submit' submitButtonAccent='viridiangreen'>
  <TagFormGroup>
    <TagEditField
    name='regexTest'
    label='Check against regex rule (postcode format)'
    value='LE6 0ZA'
    validation={[{
      rule: 'matches',
      args:'^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$'}]
    }/>
  </TagFormGroup>
</TagForm>`,
  },
};

const GreaterLessStory: Story = {
  title: 'Greater/Less then rules',
  description: 'Greater/Less then rules',
  coreComponent: {
    html: `<tag-form submit-button-text='Submit' submit-button-accent='viridiangreen'>
  <tag-form-group>
    <tag-edit-field name='Greater than rule' label='Greater than rule' data-type='integer' value='1'>
      <tag-validation rule='greaterthan' args='5'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
  <tag-form-group>
    <tag-edit-field name='Greater than or equal to rule' label='Greater than or equal to rule' data-type='integer' value='1'>
        <tag-validation rule='greaterthanorequalto' args='5'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
  <tag-form-group>
    <tag-edit-field name='Less than rule' label='Less than rule' data-type='integer' value='6'>
        <tag-validation rule='lessthan' args='5'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
  <tag-form-group>
    <tag-edit-field name='Less than or equal to rule' data-type='integer' label='Less than or equal to rule' value='6'>
        <tag-validation rule='lessthanorequalto' args='5'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
</tag-form>`,
  },
  reactWrapper: {
    jsx: `<TagForm submitButtonText='Submit' submitButtonAccent='viridiangreen'>
  <TagFormGroup>
    <TagEditField
    name='Greater than rule'
    label='Greater than rule'
    value='1'
    validation={[{ rule: 'greaterthan', args:'5'}]}/>
    <TagEditField
    name='Greater than or equal rule'
    label='Greater than or equal rule'
    value='1'
    validation={[{ rule: 'greaterthanorequalto', args:'5'}]}/>
    <TagEditField
    name='Less than rule'
    label='Less than rule'
    value='6'
    validation={[{ rule: 'lessthan', args:'5'}]}/>
    <TagEditField
    name='Less than or equal rule'
    label='Less than or equal rule'
    value='6'
    validation={[{ rule: 'lessthanorequalto', args:'5'}]}/>
  </TagFormGroup>
</TagForm>`,
  },
};

const HttpStory: Story = {
  title: 'Http response rules',
  description: 'Http response rules',
  coreComponent: {
    html: `<tag-form submit-button-text='Submit' submit-button-accent='viridiangreen'>
  <tag-form-group>
    <tag-edit-field name='In http response rule' label='In http response rule' value='Luke Vader'>
        <tag-validation rule='inHttpResponse' args='{"path": "https://swapi.dev/api/people/?page=1", "responseBodyArrayProp": "results", "objectProp": "name"}'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
  <tag-form-group>
    <tag-edit-field name='Not in http response rule' label='Not in http response rule' value='Luke Skywalker'>
        <tag-validation rule='notinhttpresponse' args='{"path": "https://swapi.dev/api/people/?page=1", "responseBodyArrayProp": "results", "objectProp": "name"}'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
</tag-form>`,
  },
  reactWrapper: {
    jsx: `<TagForm submitButtonText='Submit' submitButtonAccent='viridiangreen'>
  <TagFormGroup>
    <TagEditField
    name='In http response rule'
    label='In http response rule'
    value='Luke Vader'
    validation={[{ rule: 'inhttpresponse', args:'{"path": "https://swapi.dev/api/people/?page=1", "responseBodyArrayProp": "results", "objectProp": "name"}'}]}/>
  </TagFormGroup>
  <TagFormGroup>
    <TagEditField
    name='Not in http response rule'
    label='Not in http response rule'
    value='Luke Skywalker'
    validation={[{ rule: 'notinhttpresponse', args:'{"path": "https://swapi.dev/api/people/?page=1", "responseBodyArrayProp": "results", "objectProp": "name"}'}]}/>
  </TagFormGroup>
</TagForm>`,
  },
};

const DateStory: Story = {
  title: 'Date rules',
  description: 'Date rules',
  coreComponent: {
    html: `<tag-form submit-button-text='Submit' submit-button-accent='viridiangreen'>
  <tag-form-group>
    <tag-edit-field name='GreaterThan' label='Greater than date' value='15/03/2019' editor="datepick" data-type="date">
        <tag-validation rule='greaterthan' args='20/03/2019'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
  <tag-form-group>
    <tag-edit-field name='LessThan' label='Less than date' value='25/03/2019' editor="datepick" data-type="date">
      <tag-validation rule='lessthan' args='20/03/2019'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
</tag-form>`,
  },
  reactWrapper: {
    jsx: `<TagForm submitButtonText='Submit' submitButtonAccent='viridiangreen'>
  <TagFormGroup>
    <TagEditField
    name='Greater than date'
    label='GreaterThan'
    value='15/03/2019'
    editor='datepick'
    dataType='date'
    validation={[{ rule: 'greaterthan', args:'20/03/2019'}]}/>
  </TagFormGroup>
  <TagFormGroup>
    <TagEditField
    name='Less than date'
    label='LessThan'
    value='25/03/2019'
    editor='datepick'
    dataType='date'
    validation={[{ rule: 'lessthan', args:'20/03/2019'}]}/>
  </TagFormGroup>
</TagForm>`,
  },
};

const CustomStory: Story = {
  title: 'Custom rule',
  description: 'Custom rule',
  coreComponent: {
    html: `<tag-form submit-button-text='Submit' submit-button-accent='viridiangreen'>
  <tag-form-group>
    <tag-edit-field name='field' label='Enter something'>
        <tag-validation execute-on='blur'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
</tag-form>`,
    js: `var tagValidation = document.querySelector('tag-validation');
tagValidation.componentOnReady().then(function() {
  tagValidation.rule = function(values, fieldName, args, dataType) {
    return values[fieldName] === 'FRED' ? '' : 'You must enter FRED';
  };
});`,
  },
  reactWrapper: {
    jsx: `<TagForm submitButtonText='Submit' submitButtonAccent='viridiangreen'>
  <TagFormGroup>
    <TagEditField
    name='field'
    label='Enter something'
    validation={[{ rule: (values, fieldName, args, dataType) =>
      values[fieldName] === 'FRED' ? '' : 'You must enter FRED'}]}/>
  </TagFormGroup>
</TagForm>`,
  },
};

const DisplayValidationMessageStory: Story = {
  title: 'Display validation message',
  description: 'Display validation message',
  coreComponent: {
    html: `<tag-form submit-button-text='Submit' submit-button-accent='viridiangreen'>
  <tag-form-group>
    <tag-edit-field name='overlayField' label='Overlay' display-validation-message='overlay' validation-auto-size>
      <tag-validation rule='required' execute-on='blur' message='Overlay validation'></tag-validation>
    </tag-edit-field>
    <tag-edit-field name='flowField' label='Flow' display-validation-message='flow' validation-auto-size>
      <tag-validation rule='required' execute-on='blur' message='Flow validation'></tag-validation>
    </tag-edit-field>
  </tag-form-group>
</tag-form>`,
  },
  reactWrapper: {
    jsx: `<TagForm submitButtonText='Submit' submitButtonAccent='viridiangreen'>
  <TagFormGroup>
    <TagEditField
    name='overlayField'
    label='Overlay'
    displayValidationMessage='overlay'
    validationAutoSize
    validation={[{ rule: 'required', message:'Overlay validation'}]}
    />
    <TagEditField
    name='flowField'
    label='Flow'
    displayValidationMessage='flow'
    validationAutoSize
    validation={[{ rule: 'required', message:'Flow validation'}]}
    />
  </TagFormGroup>
</TagForm>`,
  },
};

const RemoteValidationStory: Story = {
  title: 'Remote validation',
  description: 'An example of form with a field that is validated on button click',
  coreComponent: {
    html: `
  <tag-form submit-button-hidden="true">
    <tag-form-group>
      <tag-edit-field name='email' label='Email'>
        <tag-validation rule='required' execute-on='remote'></tag-validation>
        <tag-validation rule='email' execute-on='remote'></tag-validation>
      </tag-edit-field>
    </tag-form-group>
    <div slot="footer">
      <tag-button size='large' text='Validate' class='validate-button'></tag-button>
    </div>
  </tag-form>`,
    js: `
  var editField = document.querySelector('tag-edit-field');
  var validateButton = document.querySelector('.validate-button');
  validateButton.addEventListener('buttonClick', function () {
    editField.validateFieldRemote();
  });
  `,
  },
  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const [value, setValue] = React.useState("");
    const editor = React.useRef(null);
    const button = React.useRef(null);
    React.useEffect(() => {
      button.current.tagComponent.current.addEventListener("buttonClick", function () {
        editor.current.validateFieldRemote();
      });
    }, [])
    return (
    <div>
      <TagForm
        submitButtonHidden={true}
      >
        <TagFormGroup>
          <TagEditField name='email' label='Email' value={value} ref={editor}
            onValueChange={(e) => { setValue(e.detail.value); }}
            validation={[
              { rule: 'required', executeOn: 'remote'},
              { rule: 'email', executeOn: 'remote'}
            ]}>
          </TagEditField>
        </TagFormGroup>
        <div slot="footer">
            <TagButton
              ref={button}
              size='large'
              text='Validate'/>
        </div>
      </TagForm>
    </div>
    )
  };`,
  },
};

export const TagValidationDocs: Component = {
  type: 'component',
  name: 'validation',
  description: 'Enables validation on a tag-edit-field',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'rule',
      description: 'The validation rule',
      type:
        'required | email | url | maxlength | minlength | inarray | notinarray | matches | greaterthan | greaterthanorequalto | lessthan | lessthanorequalto | inhttpresponse | notinhttpresponse',
    },
    {
      name: 'args',
      description: 'The argument for the validation rule',
      type: 'any',
    },
    {
      name: 'message',
      description: 'The message that the user should receive when the validation check fails',
      type: 'string',
    },
    {
      name: 'executeOn',
      description: 'When the rule should execute',
      type: 'valueChange | blur | remote',
      default: 'blur',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [
    {
      name: 'validateRemote',
      description: 'Triggers the remote validation rules to be invoked on the edit field',
      parameters: [],
      returnType: 'void',
    },
  ],
  stories: [
    RequiredStory,
    EmailStory,
    UrlStory,
    LengthStory,
    ArrayStory,
    MatchStory,
    RegexStory,
    RegexStoryPostcode,
    GreaterLessStory,
    HttpStory,
    DateStory,
    CustomStory,
    DisplayValidationMessageStory,
    RemoteValidationStory,
  ],
};
